import type { FaireProductEntity } from "../../entity_types/product";

export const p_y7zpstyrb7: FaireProductEntity = {
  token: "p_y7zpstyrb7",
  type: "product",
  name: "6\" Squishy Saguaro Cactus Plushie • Hugs from Arizona",
  brandToken: "b_40uiyujpi6",
  brandName: "Plushology® by RGU",
  imageUrl: "https://cdn.faire.com/fastly/58f795445871d88868a63fb7c6a8f9561f12c13e77524650794f7341eddae2df.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.7,
  description: "Ah, the iconic saguaro!  Your Arizona statement just wouldn't be the same without it.  Crafted with care from super soft materials and featuring an embroidered face, this little desert dweller is safe for children of all ages (conforms to safety regulations of ASTMF963).  Smooshy to the touch and with plastic pellets in the base for stability on your store shelf, they're ready for play and just right for little hands and imaginative minds. The sublimated (a printing process whereby the graphic is embedded in the fabric and will never peel off) message on their torso features an uplifting message which is sure to bring a smile to the recipients face. Measuring 6\" tall, this plushy makes a heartfelt keepsake that's perfect for anyone seeking a memento of their visit to the beautiful state of Arizona!",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:58.720Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
